import { FiXCircle } from 'react-icons/fi';
import { useTheme } from 'styled-components';
import { IDistrictViewModel } from 'viewModels';
import { useEffect, useState } from 'react';
import { IUpdateDistrictsOfOperationInputModel } from 'inputModels';
import { Container, Content } from './styles';
import { FormDistrictsOfOperation } from '../../FormDistrictsOfOperation';
import { Button } from '../../Buttons/Button';
import { useDistricts } from '../../../context/districts';
import { UserController } from '../../../controller/UserController';
import { useAlert } from '../../../hooks/useAlert';
import { useApp, useRegisterForm } from '../../../context';

interface UpdateDistrictsOfOperationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

export function UpdateDistrictsOfOperationModal({
  isOpen,
  onRequestClose,
}: UpdateDistrictsOfOperationModalProps) {
  const { setIsServiceProvider } = useRegisterForm();
  const { setLoading } = useApp();
  const alert = useAlert();
  const theme = useTheme();

  const {
    districtsSelectedsByUser,
    hasNextPageDistrictsSelectedByUser,
    setDistrictsSelectedsByUser,
  } = useDistricts();
  const [districtsSelected, setDistrictsSelected] = useState<IDistrictViewModel[]>([]);

  const handleClose = () => {
    onRequestClose();
  };

  const handleUpdateDistrictsOfOperation = async () => {
    const removedDistricts = districtsSelectedsByUser.filter(
      (d) => !districtsSelected.find((s) => s.id === d.id),
    );
    const addedDistricts = districtsSelected.filter(
      (d) => !districtsSelectedsByUser.find((s) => s.id === d.id),
    );
    const input: IUpdateDistrictsOfOperationInputModel = {
      districtsAddedId: addedDistricts.map((d) => d.id),
      districtsRemovedId: removedDistricts.map((d) => d.id),
    };
    setLoading(true);
    await UserController.updateDistrictsOfOperationUser(input)
      .then(() => {
        handleClose();
        setIsServiceProvider(true);
        setDistrictsSelectedsByUser(districtsSelected);
        alert.show({ message: 'Comarcas de atuação atualizadas com sucesso!', type: 'success' });
      })
      .catch(() => {
        handleClose();
        alert.show({ message: 'Erro ao atualizar comarcas de atuação!', type: 'error' });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setDistrictsSelected(districtsSelectedsByUser);
  }, [districtsSelectedsByUser]);

  return (
    <Container
      overlayClassName="react-modal-overlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}>
      <header>
        <h1>Comarcas de Atuação</h1>
        <button type="button" onClick={handleClose}>
          <FiXCircle
            size={22}
            fill={theme.colors.tertiary_500}
            color={theme.colors.background_white}
            style={{ flexShrink: 0 }}
          />
        </button>
      </header>
      <Content>
        <FormDistrictsOfOperation
          handleDistrictsSelected={(districts) => setDistrictsSelected(districts)}
        />
      </Content>
      <div className="containerButtons">
        <Button
          text="Cancelar"
          dimensions={{ width: '12rem', height: '2rem' }}
          font={{ size: '14' }}
          color="background_white"
          background="primary"
          backgroundHoverColor="tertiary_500"
          textHoverColor="background_white"
          onClick={handleClose}
        />
        <Button
          text={hasNextPageDistrictsSelectedByUser ? 'Carregando comarcas...' : 'Salvar'}
          dimensions={{ width: '12rem', height: '2rem' }}
          font={{ size: '14' }}
          color="background_white"
          background="secondary"
          type="button"
          styleRightComponent={{ fontSize: '0.5rem' }}
          disabled={hasNextPageDistrictsSelectedByUser}
          backgroundHoverColor="tertiary_500"
          textHoverColor="background_white"
          border={{ color: 'primary' }}
          onClick={handleUpdateDistrictsOfOperation}
        />
      </div>
    </Container>
  );
}
